import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import { CurrencyProvider } from "@/lib/currency";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import AuthCallback from "@/pages/AuthCallback";
import Pricing from "@/pages/Pricing";
import BillingSuccess from "@/pages/BillingSuccess";
import AdminUsers from "@/pages/AdminUsers";
import AdminBankTransfers from "@/pages/AdminBankTransfers";
import AdminPayments from "@/pages/AdminPayments";
import SuperAdminLogin from "@/pages/SuperAdminLogin";
import SuperAdminDashboard from "@/pages/SuperAdminDashboard";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/app/DashboardLayout";
import ProjectsView from "@/pages/dashboard/ProjectsView";
import WritingView from "@/pages/dashboard/WritingView";
import TemplatesView from "@/pages/dashboard/TemplatesView";
import JuryView from "@/pages/dashboard/JuryView";
import SecurityView from "@/pages/dashboard/SecurityView";
import SeguridadView from "@/pages/dashboard/SeguridadView";
import VerifyReceiptPage from "@/pages/VerifyReceiptPage";
import TermsPage from "@/pages/legal/Terms";
import PrivacyPage from "@/pages/legal/Privacy";
import ProjectEditor from "@/pages/dashboard/ProjectEditor";
import { Toaster } from "@/components/ui/sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: process Google OAuth callback BEFORE normal routes (prevents race)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route path="/pricing" element={<Pricing />} />
      <Route path="/terminos" element={<TermsPage />} />
      <Route path="/privacidad" element={<PrivacyPage />} />
      <Route path="/verify/:hash" element={<VerifyReceiptPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<ProjectsView />} />
        <Route path="writing" element={<WritingView />} />
        <Route path="templates" element={<TemplatesView />} />
        <Route path="jury" element={<JuryView />} />
        <Route path="security" element={<SecurityView />} />
        <Route path="blindaje" element={<SeguridadView />} />
        <Route path="projects/:projectId" element={<ProjectEditor />} />
      </Route>
      <Route
        path="/billing/success"
        element={
          <ProtectedRoute>
            <BillingSuccess />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute roles={["admin", "superadmin"]}>
            <AdminUsers />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/bank-transfers"
        element={
          <ProtectedRoute roles={["admin", "superadmin"]}>
            <AdminBankTransfers />
          </ProtectedRoute>
        }
      />
      <Route path="/superadmin/login" element={<SuperAdminLogin />} />
      <Route
        path="/superadmin"
        element={
          <ProtectedRoute role="superadmin">
            <SuperAdminDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Landing />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <AppRouter />
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
